module.exports = __webpack_public_path__ + "img/泗水滩底古荔园.3d33a318.png";